import React from 'react'
import MyButton from '../UI/form/MyButton'
import { useNavigate } from 'react-router-dom'

const WorkLinePlaceNotData = () => {

    const navigate = useNavigate()

  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>Для початку виконання робочих функцій необхідно спочатку зафіксуватись в приміщенні</p>
        <MyButton
            onClick={e => navigate('/user/work-place')}
        >
            Перейти до фіксації на роботі
        </MyButton>
    </div>
  )
}

export default WorkLinePlaceNotData